import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ClientProvider } from './config/ClientProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ClientProvider>
                <App />
            </ClientProvider>
        </BrowserRouter>
    </React.StrictMode>
);
